const translation = {
  offRules: 'Official Rules',
  // Navigation pages
  play: 'PLAY',
  recent: 'RECENT',
  howToPlay: 'HOW TO PLAY',

  // Card
  signUp: 'SIGN UP TO PLAY',
  viewMy: 'VIEW MY CARD',
  view: 'VIEW CARD',
  registered: 'REGISTERED',
  entry: 'Entry',
  entries: 'Entries',
  contestClosed: 'BINGO CONTEST CLOSED',
  ifNecessary: 'IF NECESSARY',

  //Signup modal
  reg: 'You are registered to play Olybet Bingo',
  rel: 'Your Bingo Card will be revealed in:',
  come: 'Come back to see your card when the event begins',
  priz: 'Prizing',
  regen: 'Bingo card auto-scores during game',
  //Wait modal
  hangTight: 'HANG TIGHT!',
  cardToBeGenerated: 'Waiting for BINGO CARD TO BE GENERATED.',
  mayTakeUpFewMinutes: 'THIS CAN TAKE UP TO A FEW MINUTES',

  // How to play page
  vert: 'VERTICAL',
  horiz: 'HORIZONTAL',
  diag: 'DIAGONAL',
  fullCard: 'FULL CARD',
  earnEntriesIntoDraw:
    'EARN PRIZES FOR GETTING A FULL ROW, DIAGONAL OR FULL CARD. YOUR CELLS WILL SCORE IF THE EVENT IN THE CELL BECOMES TRUE.',
  earnEntryIntoDraw:
    'EARN AN ENTRY INTO THE DRAW WITH EACH FULL OR DIAGONAL ROW. YOUR CELLS WILL SCORE IF THE EVENT IN THE CELL BECOMES TRUE.',
  autoScoresDuringGame: 'BINGO CARD AUTO-SCORES DURING GAME',
  clickForMoreInfo: 'For more information, click here for',
  SOG: 'SOG – Shot on Goal (any shot scored as a shot on goal. Does not include blocked shots or shots that hit the post)',
  PPG: 'PPG – Power Play Goal (a goal scored by a team playing with a man advantage. For example, a team that is playing at a man advantage of 5v4, 5v3, or 4v3)',
  SHG: 'SHG – Short-Handed Goal (a goal scored by a team with a player currently serving a penalty)',
  PIM: 'PIM – Penalties in Minutes',
  FOPercent: 'FO% - Face-off Percentage',
  PTS: 'PTS – Points (either a goal or an assist)',
  entryPerRow: 'ENTRY PER ROW',
  totalEntries: 'TOTAL ENTRIES',
  perRow: 'PER ROW',

  //Home page
  bingoMayTakeUp:
    'Bingo cards may take up to 30 minutes post game to score all events',
  welcomeTo: 'Welcome to BingOly!',
  reviewInRecent: 'Review your past cards in the recent tab',
  noBingolyGames:
    'No BingOly Games currently available. Come back soon to play!',
  thanksForPlaying: '',
  agreeToRules: 'By signing up you acknowledge and agree to the',

  //Recent page
  noRecentContests: 'No recent contests',
  //Game field page
  gamePrizeText:
    'Win a €100 Freebet if you score all of your cells or a €5 Freebet if you manage to get at least one row or a diagonal. Prizes will be distributed in working hours.',
  cardUpdateAfterPeriod: 'Card will update every 30 minutes',
  anyLine: 'ANY LINE',
  vertLines: 'VERT LINES',
  line: 'LINE',
  horzLines: 'HORZ LINES',

  //Onboarding page
  letsGetStarted: 'Let’s Get Started',
  makeSureToEnterSelections:
    'Make sure to enter your selections each day to compete for daily prizes. Remember to enter your selection for the tie breaker question before submitting your pick. You can edit your picks up until the start of the live game. Earn points for each correct prediction made.',
  playWithFriends:
    'Play with Friends. Who’s got game? Challenge your friends to play in a private league. Go to the leaderboard section, hit the Create button to start, and share the PIN code with your friends to join.',
  scoring: 'Scoring',
  challengeFriends: 'Challenge Friends',
  skip: 'skip',
  next: 'next',

  logout: 'Log out',
  returnToGamezone: 'Return to GameZone',
  rules: 'RULES',
  back: 'Back',

  bingo: 'BingOly',
  justAFewMinutes: 'Just a few minutes, please refresh the page',
  fourCorners: 'FOUR CORNERS',
  rulesNotFound: 'Rules not found',
  offWebsiteText:
    'OFFICIAL WEBSITE OF THE EVENT WILL BE CONSIDERED AS PRIMARY SOURCE OF RESULTS. IF NOT AVAILABLE OTHER REPUTABLE SOURCES OR LIVE FOOTAGE WILL BE USED.',
  accountInfo: 'Account Information',
  availableGames: 'Available Games',
  backToOlybet: 'Back to OlyBet',
  confirmNewPassword: 'Confirm New Password',
  confirmNewPasswordIsRequired: 'Confirm New Password is a required field',
  confirmPassword: 'Confirm Password',
  confirmPasswordIsRequired: 'Confirm Password is a required field',
  contactNumber: 'Contact number',
  country: 'Country',
  countryIsRequired: 'Country is a required field',
  continue: 'Continue',
  days: 'Days',
  didNotMeanToUnsubscribe: 'Didn’t mean to unsubscribe?',
  email: 'Email',
  emailAddressAlreadyInUse: 'Email address already in use',
  emailIsRequired: 'Email is a required field',
  emailOrUsername: 'Email or username',
  emailOrUsernameIsRequired: 'Email or username is a required field',
  enterYourDetails: 'Please enter your details below',
  enterYourEmail: 'Enter your email to reset password',
  errorDuringLogin: 'Error during login',
  errorDuringRegistration: 'Error during registration',
  errorDuringSubscribing: 'Error during subscribing',
  errorDuringUnsubscribing: 'Error during unsubscribing',
  errorUpdatingProfile: 'Error updating profile',
  firstName: 'First Name',
  firstNameIsRequired: 'First Name is a required field',
  firstNameMusBeAtLeast: 'First Name must be at least 3 characters',
  firstNameMustNotExceed: 'First Name must not exceed 100 characters',
  forgotPassword: 'Forgot Password',
  full: 'FULL',
  gameDetails: 'Game details',
  gamezone: 'Gamezone',
  getResetLink: 'Get reset link',
  goodbye: 'GOODBYE',
  history: 'History',
  inappropriateWordsNotAllowed:
    'Inappropriate words and phrases are not allowed',
  informationAndPromotionalAgreement:
    'I agree to the Rules of the Game and confirm that the Rules of the Game are acceptable, clear and understandable to me. I acknowledge that I have read the rules which are available at:',
  inOrderToPlayAndRedeemPrizes:
    'In order to play and redeem prizes, your details must be accurate and verified. Some prizes are paid out to an OlyBet account, to receive those prizes you need to have an OlyBet account with matching details (name and email).',
  invalidCredentials: 'Invalid credentials',
  invalidEmailFormat: 'Invalid email format',
  itIsRequiredField: 'It is a required field',
  joinNow: 'Join Now',
  lastName: 'Last Name',
  laststNameIsRequired: 'Last Name is a required field',
  laststNameMusBeAtLeast: 'Last Name must be at least 3 characters',
  laststNameMustNotExceed: 'Last Name must not exceed 100 characters',
  legalConsent:
    'I consent to the processing of my personal data for the purposes of processing the Game and handling complaints. I confirm that I have read and understood the Privacy Policy available at:',
  lines: 'LINES',
  live: 'LIVE',
  liveGames: 'Live Games',
  login: 'Login',
  marketingConsent:
    'I consent to the processing of my personal data for direct marketing purposes',
  marketingConsentSidebar: 'Consent to marketing',
  mobileNumber: 'Mobile number',
  mobileNumberIsRequired: 'Mobile number is a required field',
  mobileNumberMustBeAtLeast: 'Mobile number must be at least 6 characters',
  mobileNumberMustNotExceed: 'Mobile number must not exceed 15 characters',
  mustBeChecked: 'Must be checked',
  mustContainFrom8To20Characters: 'Must contain from 8 to 20 characters',
  mustContainOneLowercase: 'Must contain at least one lowercase',
  mustContainOneNumber: 'Must contain at least one number',
  mustContainOneUppercase: 'Must contain at least one uppercase',
  myContest: 'My Contests',
  myHistory: 'My History',
  nationality: 'Nationality',
  newPassword: 'New Password',
  newPasswordIsRequired: 'New Password is a required field',
  nickname: 'Nickname',
  nicknameAlredyInUse: 'Nickname already in use',
  nicknameIsRequired: 'Nickname is a required field',
  noHistoryYet: 'There is no history yet',
  noUpcomingContestsYet: 'There are no upcoming contests yet',
  oops: 'Oops! Something went wrong...',
  over$PrizeValueWon: 'Over <1>$1,000,000</1> prize value won',
  password: 'Password',
  passwordDoNotMatch: 'Password do not match',
  passwordIsRequired: 'Password is a required field',
  passwordNotMeetCriteria: 'Password does not meet criteria',
  passwordSuccessfullyReset: 'Password successfully reset',
  personalDetails: 'Personal Details',
  playNow: 'Play now',
  pleaseCheckYourEmailInbox: 'Please check your email inbox',
  pos: 'POS',
  preferences: 'Preferences',
  profile: 'Profile',
  pts: 'PTS',
  recentWinners: 'Recent Winners',
  region: 'Region',
  resetLinkSent: 'Reset link sent',
  resetPassword: 'Reset Password',
  resubscribe: 'Resubscribe',
  returnToLogin: 'Return to login',
  saveChanges: 'Save changes',
  signIn: 'Sign in',
  success: 'Success!',
  successfullyLoggedIn: 'Successfully logged in',
  successfullySentResetLink: 'Successfully sent reset link to your email',
  successfullySignedUp: 'Successfully signed up',
  successfullySubscribed: 'Successfully subscribed',
  successfullyUnsubscribed: 'Successfully unsubscribed',
  successfullyUpdatedProfile: 'Successfully updated profile',
  unsubscribe: 'Unsubscribe',
  upload: 'Upload',
  username: 'Username',
  usernameAlreadyInUse: 'Username already in use',
  usernameIsRequired: 'Username is a required field',
  veryStrongPassword: 'Very strong password',
  welcomeBack: 'Welcome Back!',
  win: 'WIN',
  winner: 'Winner',
  youHaveSuccesfullyUnsubscribed:
    "You've succesfully unsubscribed from OlyBet's Marketing.",
  yourEmail: 'Your email',
  youWishToUnsubscribe:
    'If you are sure you wish to unsubscribe from OlyBet’s Marketing please click below.',
  zipCode: 'Zip code',
  zipCodeIsRequired: 'ZIP code is a required field',
  zipCodeMustBeAtLeast: 'ZIP code must be at least 3 characters',
  winPrizes:
    'WIN PRIZES BY SCORING ROWS ON YOUR BINGOLY CARD DURING A LIVE GAME.',
  letsGo: "Let's go",
  inAnyCase:
    'We will still contact you to send important information related to your entries into games, for example confirmation of a prize you have won. Please consult our Privacy Notice for more information about how your personal data is processed.',
  termsAndConditions: 'Terms & Conditions',
  privacyNotice: 'Privacy notice',
};

export default translation;
